import React, { createContext, useState, useContext, useCallback } from "react";
import { fetchTransactions, createTransaction } from "../api/api";
import { useAccounts } from "./AccountContext";

// We remove useAuthenticatedEffect here to avoid double calls

const TransactionContext = createContext();

export const useTransactions = () => useContext(TransactionContext);

export const TransactionProvider = ({ children }) => {
  const [transactions, setTransactions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  // const [lastLoadedPage, setLastLoadedPage] = useState(null);

  const { accounts, loading: accountsLoading, fetchAccountsData } = useAccounts();

  // hybrid approach: fetch all transactions for a date range in one shot
  const loadTransactions = useCallback(async (page = 1, pageSize = 20, filters = {}) => {
    setLoading(true);
    try {
      const data = await fetchTransactions(page, pageSize, filters);
      if (data?.results) {
        // data is an array of transaction objects
        setTransactions(data.results);
        setTotalCount(data.count || 0);
      } else {
        // fallback if data is not an array
        setTransactions([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error loading transactions:", error);
    } finally {
      setLoading(false);
    }
  }, []);


  /**
   * fetchAllTransactions
   * Repeatedly calls the paginated endpoint until `next` is null
   * returns an array of all results.
   */
  const fetchAllTransactions = useCallback(
    async (filters = {}) => {
      // but returns the entire dataset for chart usage, etc.
      setLoading(true);
      try {
        let page = 1;
        let pageSize = 100; // or 20
        let allResults = [];
        let hasNext = true;

        while (hasNext) {
          const data = await fetchTransactions(page, pageSize, filters);
          if (!data?.results) break; // if empty or error
          allResults = [...allResults, ...data.results];
          if (data.next) {
            page += 1;
          } else {
            hasNext = false;
          }
        }
        return allResults;
      } catch (error) {
        console.error("Error fetching all transactions:", error);
        return [];
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const createNewTransaction = async (newTransaction) => {
    try {
      console.log("Creating new transaction:", newTransaction);
      const response = await createTransaction(newTransaction);
      console.log("Transaction created:", response);
      // Optionally add it to front, or just reload the current page
      setTransactions((prev) => [response, ...prev]);

      // refresh accounts if needed
      await fetchAccountsData();

      // reload first page or your `lastLoadedPage`
      // await loadTransactions(lastLoadedPage || 1, 20, false);
    } catch (error) {
      console.error("Error creating transaction", error);
    }
  };

  return (
    <TransactionContext.Provider
      value={{
        transactions,
        totalCount,
        loading,
        createNewTransaction,
        accounts,
        accountsLoading,
        loadTransactions,
        fetchAllTransactions,
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
};
// end of added

